<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-header-title">
        <template v-if="isFiltered">
          <strong>필터된 수업</strong> 현황
        </template>
        <template v-else>
          <strong>오늘 전체</strong> 수업 현황
        </template>
      </h4>
    </div>

    <el-table
	  v-if="data.length"
      ref="lessonStatusTable"
      v-loading="loading"
      class="fifl-table lesson-status-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      row-class-name="fifl-table-row"
      cell-class-name="fifl-table-cell"
      max-height="618"
      row-key="id"
      :data="data"
    >
      <el-table-column
        label="시간"
        sortable
        fixed
        :width="tableColWidth.start"
        prop="start"
      >
        <template slot-scope="scope">
          <span class="table-time">{{ presentCourseDuration(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="parent_course"
        label="수업"
        sortable
		show-overflow-tooltip
        :width="tableColWidth.parent_course"
      />
      <el-table-column
        prop="instructors"
        label="강사"
        sortable
        :width="tableColWidth.instructors"
      >
        <template slot-scope="scope">
          {{ scope.row.instructors.join(', ') }}
        </template>
      </el-table-column>
      <el-table-column
        :width="tableColWidth.attendanceGraph"
      >
        <template slot-scope="scope">
          <el-popover
            placement="bottom"
            width="170"
            popper-class="progress-popup"
            :visible-arrow="false"
            trigger="hover"
          >
            <div>
              <span>{{ presentCourseDuration(scope.row) }}</span>
              <h2>{{ scope.row.parent_course }}</h2>
              <ul>
                <li><div /> <p>정원</p> <span>{{ scope.row.quota }}</span></li>
				<li v-show="isBookingSystem">
					<div /> <p>대기</p> <span>{{ scope.row.waiting }}</span>
				</li>
                <li v-show="isBookingSystem">
                  <div /> <p>예약</p> <span>{{ scope.row.booking }}</span>
                </li>
                <li><div /> <p>출석</p> <span>{{ scope.row.attendance }}</span></li>
                <li><div /> <p>지각</p> <span>{{ scope.row.late }}</span></li>
                <li><div /> <p>결석</p> <span>{{ scope.row.absence }}</span></li>
              </ul>
            </div>
            <el-progress-graph
              slot="reference"
              :data="scope.row"
            />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        class-name="more-action__column"
		fixed="right"
        :width="tableColWidth.actionDropdown"
      >
        <template slot-scope="scope">
          <el-dropdown
            style="float: right;"
            trigger="click"
            @command="handleChildCourseCommand"
          >
            <span class="el-dropdown-link">
              <div class="more-action__button ic-more" />
            </span>
            <el-dropdown-menu
              slot="dropdown"
              class="status-dropdown__menu"
            >
              <el-dropdown-item
                v-for="(dropdownItem, dropdownIndex) in dropdownItems"
                :key="dropdownIndex"
                :command="makeCommandData(dropdownItem.command, scope.row)"
                :disabled="dropdownItem.disabled"
              >
                {{ dropdownItem.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
	<empty-table 
      v-else
	  :props-loading-status="loading"
      :props-has-parent="emptyTableProps.hasParent"
      :props-is-icon="emptyTableProps.isIcon"
      :props-header-height="emptyTableProps.headerHeight"
      :props-data="emptyTableProps.data"
      :props-table-body-height="emptyTableProps.bodyHeight"
      :props-message="emptyTableProps.message" 
    />
  </div>
</template>

<script>
import EmptyTable from "@/components/EmptyTable"
import ElProgressGraph from "@/components/element-ui/ElProgressGraph";
import dateFns from "date-fns";
import { COURSE_DIALOG_TAB } from "@/constants";
import { fiflboxApi } from '@/utils/api';

const COURSE_EXCLUSION_DUPLICATED_MESSAGE = "필드 child_course, dt 는 반드시 고유(unique)해야 합니다."
const RESPONSIVE_TABLE_WIDTH = {
	mobile: {
		start: 80,
		parent_course: 110,
		instructors: 80,
		attendanceGraph: 200,
		actionDropdown: 50,
	},
	desktop: {
		start: 90,
		parent_course: 150,
		instructors: 150,
		attendanceGraph: null,
		actionDropdown: 50,
	},
};

export default {
	name: "LessonStatusTable",
	components: { ElProgressGraph,EmptyTable },
	props: ["data", "isFiltered", "loading"],
	data() {
		return {
			dropdownItems: [
				{
					name: "수업 취소",
					disabled: false,
					command: {
						action: "CANCELLED",
					},
				},
				{
					name: "수업 변경",
					disabled: false,
					command: {
						action: "MODIFY",
					},
				},
				{
					name: "상세 보기",
					disabled: false,
					command: {
						action: "DETAIL",
					},
				},
			],
	emptyTableProps: {
        message : '개설된 수업이 없습니다.',
        bodyHeight: 70,
        isIcon : false,
        hasParent : true,
        headerHeight:51,
        data :  [
          {label:'시간', width: 80+'px'},
          {label:'수업', width: 110+'px'},
          {label:'강사', width: 80+'px'},
        ]
      },
		};
	},
	computed: {
		tableColWidth() {
			let isMobileWidth = window.innerWidth < 768;

			return RESPONSIVE_TABLE_WIDTH[isMobileWidth ? "mobile" : "desktop"];
		},
		isBookingSystem() {
			return this.$store.getters.getIsBookingSystem;
		},
	},
	methods: {
		makeCommandData(command, data) {
			return {
				...command,
				data,
			};
		},
		presentCourseDuration({ start, duration }) {
			let end = dateFns.addMinutes(start, duration);
			return `${dateFns.format(start, "HH:mm")} - ${dateFns.format(
				end,
				"HH:mm"
			)}`;
		},
		async deleteChildCourse(childCourse) {
			if (dateFns.isBefore(childCourse.start, dateFns.startOfDay(new Date()))) {
				await this.$alert(
					"과거의 수업은 삭제할 수 없습니다.",
					"수업 삭제 불가",
					{
						confirmButtonText: "확인",
						showClose: false,
						customClass: "fifl-message-box",
						confirmButtonClass: "gray",
						cancelButtonClass: "white",
						closeOnPressEscape: false,
					}
				);

				return;
			}

			if (childCourse.booking > 0) {
				try {
					await this.$confirm(
						"모든 예약을 취소한 후 수업을 삭제해주시길 바랍니다.",
						"예약 내역이 존재합니다.",
						{
							confirmButtonText: "확인",
							cancelButtonText: "모든 예약 취소",
							showClose: false,
							customClass: "fifl-message-box",
							confirmButtonClass: "gray",
							cancelButtonClass: "white",
							closeOnPressEscape: false,
						}
					);

					return;
				} catch (err) {}
			}

			try {
				if (childCourse.recurrence) {
          await fiflboxApi.v1.postCourseExclusions({
						dt: childCourse.start,
						child_course: childCourse.id,
					});
				} else {
          await fiflboxApi.v2.deleteChildCourses(childCourse.id);
				}

				this.$message("수업이 삭제됐습니다.");
				this.$emit("update");
			} catch (err) {
        if (err.response.data['non_field_errors']) {
          if (err.response.data['non_field_errors'].includes(COURSE_EXCLUSION_DUPLICATED_MESSAGE)) {
            this.$message("이미 삭제된 수업입니다.");
            return this.$emit("update");
          }
        }

        if (!err.isAlreadyHandled) {
					this.$message("수업 삭제 중 에러가 발생하였습니다." + err);
				}
			}
		},
		async handleChildCourseCommand({ action, data }) {
			if (action === "CANCELLED") {
				await this.deleteChildCourse(data);
			}

			if (action === "DETAIL") {
				this.$router.push({
					path: "schedule",
					query: {
						childCourseId: data.id,
						dt: data.start,
						dialogTab: COURSE_DIALOG_TAB.BOOKING,
					},
				}).catch(()=>{});
			}

			if (action === "MODIFY") {
				this.$router.push({
					path: "schedule",
					query: {
						childCourseId: data.id,
						dt: data.start,
						dialogTab: COURSE_DIALOG_TAB.COURSE_INFO,
					},
				}).catch(()=>{});
			}
		},
	},
};
</script>

<style lang="scss">
.lesson-status-table {
	margin-bottom: 10px;
}

.status-dropdown__menu {
	min-width: 92px;
}

.progress-popup {
	text-align: center;
	/* Combined Shape: */
	background: #ffffff;
	border: 1px solid #d3d3d3;
	box-shadow: 0 2px 12px 0 rgba(180, 180, 180, 0.19);
	border-radius: 4px;

	span {
		font-size: 10px;
		color: #4a4a4a;
		letter-spacing: -0.57px;
		text-align: center;
		line-height: 14px;
	}

	h2 {
		font-size: 14px;
		color: #4a4a4a;
		letter-spacing: -0.8px;
		text-align: center;
		line-height: 14px;
		margin: 2px auto 20px;
		font-weight: normal;
		width: 120px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	ul {
		margin: 0 auto;
		padding: 0;

		li {
			display: block;
			text-align: left;
			margin-bottom: 9px;
			padding-left: 50px;

			div {
				width: 10px;
				height: 10px;
				background-color: #f2f2f2;
				border-radius: 10px;
				display: inline-block;
			}

			&:nth-child(2) {
				div {
					background-color: #d3d3d3;
				}
			}

			&:nth-child(3) {
				div {
					background-color: #9b9b9b;
				}
			}

			&:nth-child(4) {
				div {
					background-color: #4a4a4a;
				}
			}

			&:nth-child(5) {
				div {
					background-color: #ffe707;
				}
			}

			&:nth-child(6) {
				div {
					background-color: #ff0000;
				}
			}

			p {
				margin: 0;
				margin-left: 5px;
				margin-right: 10px;
				display: inline-block;
				font-size: 12px;
				color: #4a4a4a;
				letter-spacing: -0.74px;
				line-height: 14px;
			}

			span {
				display: inline-block;
				text-align: center;
				font-size: 13px;
				color: #4a4a4a;
				letter-spacing: -0.8px;
				line-height: 14px;
			}
		}
	}
}

.table-time {
	line-height: 17px;
	font-size: 11px;
	letter-spacing: -0.6px;
	color: #9b9b9b;
}
</style>
